import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { CAutocomplete } from '@web-kc/shared/components';
import { useTranslation } from 'next-i18next';
import { useFilters } from '../../Provider';
import { useApp } from '@web-kc/core/providers';
import { useStyles } from '../useStyles';

const LotRegion: React.FC = () => {
  const { t } = useTranslation('tenders');
  const isMP = useApp() === 'rti';
  const theme = useTheme();
  const { classes } = useStyles({ theme });

  const { selectedFilters, setField, regions } = useFilters();

  const handleAutocompleteChange = (newValue: number | undefined) => {
    setField('region', newValue);
  };

  return (
    <>
      <Stack
        direction={{ lg: 'row', md: 'column', xs: 'column' }}
        alignItems={{ xs: 'flex-start', md: 'flex-start', lg: 'center' }}
        width="100%"
        mt={3.75}
        gap={{ xs: 1.25, lg: 2.5 }}
      >
        <Typography fontWeight={700} maxWidth="120px" width="100%">
          {t('tenders.modal.region')}
        </Typography>
        <Stack flexWrap="wrap" direction="row" gap={1.25} width="100%">
          <Box width="100%">
            <CAutocomplete
              fullWidth
              options={regions ?? []}
              optionValueKey="id"
              optionLabelKey="name"
              value={selectedFilters.region}
              onChange={handleAutocompleteChange}
              clearable
            />
          </Box>
        </Stack>
      </Stack>

      <Stack
        direction={{ lg: 'row', md: 'column', xs: 'column' }}
        alignItems="baseline"
        gap={{ xs: 0, lg: 2.5 }}
        mt={2.5}
      >
        <Box maxWidth="120px" width="100%" />
        <Grid container spacing={1}>
          {regions?.slice(0, 6).map((item) => (
            <Grid
              key={item.id}
              size={{ xs: 4 }}
              onClick={() => setField('region', item.id)}
              sx={{ cursor: 'pointer' }}
            >
              <Typography
                color={isMP ? 'primary.main' : 'text.main'}
                className={classes.ellipsis}
              >
                {item.name}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </>
  );
};

export default LotRegion;
